import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	formatLabelMessage: {
		id: 'jql-builder-basic.jql-editor.field.text-area-picker.aql-picker-popup.format-label-message',
		defaultMessage: 'AQL Query',
		description:
			'Instead of displaying AQL query text we display this to indicate that user have specificied a valid AQL query',
	},
	textAreaPlaceholder: {
		id: 'jql-builder-basic.jql-editor.field.text-area-picker.aql-picker-popup.text-area-placeholder',
		defaultMessage: 'Enter AQL Search',
		description: 'Text area placeholder for AQL Query',
	},
	aqlValidationInProgressMessage: {
		id: 'jql-builder-basic.jql-editor.field.text-area-picker.aql-picker-popup.aql-validation-in-progress-message',
		defaultMessage: 'Validating AQL...',
		description: 'Progress message to display when AQL Query validation is in progress',
	},
	inValidAqlErrorMessage: {
		id: 'jql-builder-basic.jql-editor.field.text-area-picker.aql-picker-popup.in-valid-aql-error-message',
		defaultMessage: 'Please enter a valid AQL query',
		description: 'Display error when the user has entered an invalid AQL query',
	},
	aqlSyntaxHelpLinkLabel: {
		id: 'jql-builder-basic.jql-editor.field.text-area-picker.aql-picker-popup.aql-syntax-help-link-label',
		defaultMessage: 'Assets Query Language syntax help',
		description: 'Message shown on the link label that directs to AQL documentation',
	},
	unableToValidateAqlErrorMessage: {
		id: 'jql-builder-basic.jql-editor.field.text-area-picker.aql-picker-popup.unable-to-validate-aql-error-message',
		defaultMessage: 'Unable to validate AQL query',
		description: "Display error when the service couldn't validate the AQL query",
	},
	retry: {
		id: 'jql-builder-basic.jql-editor.field.text-area-picker.aql-picker-popup.retry',
		defaultMessage: 'Retry',
		description: 'Retry icon tooltip text',
	},
});
